import { Button, Dialog, Text } from '@/components/DesignSystem';
import { ApiFarmerSalesperson } from '@api/interfaces';
import { Table, TableCell, TableHead, TableRow } from '@mui/material';
import { getAccountName } from '@shared/utilities/UserUtilities';
import { SemiRequired } from '@shared/utilities/UtilityTypes';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface AssociatedSellersDialogProps {
  associatedSellers: ApiFarmerSalesperson[],
  onClose: () => void,
  show: boolean,
}

export const AssociatedSellersDialog = ({
  associatedSellers,
  onClose,
  show,
}: AssociatedSellersDialogProps) => {
  const { t } = useTranslation();
  const validLinks = associatedSellers
    .filter((s) => !!s.salesperson) as SemiRequired<ApiFarmerSalesperson, 'salesperson'>[];
  const tableRows = validLinks.map((seller) => (
    <TableRow key={seller.id}>
      <TableCell>
        <Text category="title-small">{getAccountName(seller.salesperson)}</Text>
      </TableCell>
      <TableCell>
        <Text category="body-medium">{seller.commodityAssignment ?? ''}</Text>
        </TableCell>
    </TableRow>
  ));

  return (
    <Dialog
      acceptButton={(props) => (
        <Button
          {...props}
          onClick={onClose}
          testID="close-associated-sellers-dialog-button"
          variant="contained"
        >
          {t($ => $.common.actions.close)}
        </Button>
      )}
      onClose={onClose}
      open={show}
      showCloseButton={false}
      testID="associated-sellers-dialog"
      title={t($ => $.customers.associatedSellers.title)}
    >
      <Table>
        <TableHead>
          <TableCell width="50%">
            <Text category="overline">
              {t($ => $.customers.associatedSellers.sellerName)}
            </Text>
          </TableCell>
          <TableCell width="50%">
            <Text category="overline">
              {t($ => $.customers.associatedSellers.sellerAssignment)}
            </Text>
            </TableCell>
        </TableHead>
        {tableRows.length
          ? tableRows
          : (
            <TableRow>
              <TableCell colSpan={2}>
                {t($ => $.customers.associatedSellers.noAssociatedSellers)}
              </TableCell>
            </TableRow>
          )
        }
      </Table>
    </Dialog>
  );
};
